// extracted by mini-css-extract-plugin
module.exports = {"documents__container":"style_documents__container__2X4rN","documents__container-title":"style_documents__container-title__2hOOM"};